import React, { useState, useEffect, useRef } from 'react';
import config from '../../../config';
import {
  Form,
  Input,
  notification,
  Row,
  Col,
  Button,
  Modal,
  Select,
  DatePicker,
  Upload,
  Spin,
  Divider,
  Tooltip,
  Table,
  Radio,
  message,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as userActions from '../../../redux/actions/userActions';
import {
  confirmationModal,
  formItemLayout,
  tailFormItemLayout,
  PictureCell,
  showUploadFileList,
  filter,
  parseDate,
  onlyYear,
  formatDate,
  showFilesList,
  unexpectedError,
  beforeUpload,
} from '../../../common_functions';
import UploadTrigger from '../../../common_functions/UploadTrigger';
import UploadedCheck from '../../../common_functions/UploadedCheck';

const CreatePrint = props => {
  const { section, id } = useParams();
  const formRef = useRef();
  const filterFormRef = useRef();
  const dispatch = useDispatch();
  const [negativeData, setNagativeData] = useState([]);
  const [filterNegData, setFilterNegData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [print, setPrint] = useState(false);
  const [dateConfidence, setDateConfidence] = useState([]);
  const [supportData, setSupportData] = useState([]);
  const [artist, setArtist] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedNegative, setSelectedNegative] = useState(null);
  const [negRecord, setNegRecord] = useState(null);
  const [newThumbnail, setThumbnail] = useState();
  const [previewVisible, setPreviewVisible] = useState(false);
  const [portfolios, setPortfolio] = useState([]);
  const [movablePortfolio, setMovablePortfolio] = useState([]);
  const handleCancel = () => setPreviewVisible(false);
  const [filesState, setFilesState] = useState({ technique_doc: [] });
  let saveAndNext = '';

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      try {
        const { data: portfolio } = await dispatch(
          userActions.getItems('portfolio', {
            fields: ['id', 'name', 'number', 'type.name'],
            limit: '-1',
            filters: { type: { name: { _icontains: 'conceptual' } } },
          })
        );
        setPortfolio(portfolio);
        /**Get artist name*/
        let artistFullName = await dispatch(
          userActions.getItems('Artist', {
            fields: ['id', 'First_Name', 'last_name'],
            sort: '-id',
            limit: -1,
          })
        );
        setArtist(artistFullName.data);
        //get support table data
        const supData = await dispatch(
          userActions.getItems('support_table', {
            fields: ['id', 'type', 'name', 'fields'],
            limit: -1,
            filters: {
              fields: {
                _in: ['material_pos', 'work_process_pos', 'work_era', 'work_method_positive', 'work_purpose', 'object_type'],
              },
            },
          })
        );
        setSupportData(supData.data);

        //get Date confidence

        const dateConf = await dispatch(
          userActions.getItems('date_confidence', {
            fields: ['id', 'date_confidence'],
            sort: '-value',
            limit: -1,
          })
        );
        setDateConfidence(dateConf.data);

        // If print is already created then get the data of print table by print id
        if (!!(props.objectData.print && props.objectData.print.id)) {
          let negFile = '';
          let { data } = await dispatch(
            userActions.getItem('print', props.objectData.print.id, {
              fields: [
                '*,technique_doc.id,technique_doc.filename_download,negative_id.id,negative_id.thumbnail,negative_id.sheet_dimensions.label,date_confidence.date_confidence_id,portfolio,negative_id.creation_earliest,negative_id.creation_latest',
              ],
            })
          );
          data.date_confidence = data.date_confidence.map(item => item.date_confidence_id);
          data.creation_date_start_year = parseDate(data.creation_date_start_year);
          data.creation_date_end_year = parseDate(data.creation_date_end_year);
          setFilesState({ technique_doc: showUploadFileList(data?.technique_doc?.id, data?.technique_doc?.filename_download) });
          data.technique_doc = data?.technique_doc?.id;
          setPrint(data);
          formRef?.current?.setFieldsValue(data);
          setSelectedNegative(data?.negative_id?.id ?? '');
          if (data?.negative_id?.thumbnail) {
            negFile = await dispatch(userActions.getFile(data.negative_id.thumbnail));
          }
          setThumbnail(negFile);
          formRef?.current?.setFieldsValue({
            negative_id: data?.negative_id?.id,
            sheet_dimensions: data?.negative_id?.sheet_dimensions?.label,
            creation_earliest: onlyYear(data?.negative_id?.creation_earliest),
            creation_latest: onlyYear(data?.negative_id.creation_latest),
          });
          await showMovablePortfolio(data.portfolio_add_number, data.edition_set);
        }

        formRef?.current?.setFieldsValue({
          acquisition: props?.objectData?.acquisition,
          title: props.objectData.title,
        });
        // Get the collection object negative list
        let { data } = await dispatch(
          userActions.getItems('object_negative', {
            fields: [
              'id',
              'obj_name',
              'dummy',
              'alt_obj_name',
              'c_object.acquisition',
              'c_object.creator',
              'c_object.collections.name',
              'thumbnail',
              'c_object.obj_type',
              'creation_earliest',
              'creation_latest',
              'sheet_dimensions.label',
            ],
            sort: '-id',
            limit: -1,
            // filters: {
            //   collection_id: {
            //     _eq: props.objectData.collections,
            //   },
            // },
          })
        );
        setNagativeData(data);
        let filTableData = [];
        data.map(item => {
          let item_obj = {
            id: item.id,
            obj_name: item.obj_name,
            acquisition: item.c_object[0]?.acquisition,
            name: item?.c_object[0]?.collections?.name,
            thumbnail: item.thumbnail,
            alt_obj_name: item.alt_obj_name,
            creation_earliest: onlyYear(item?.creation_earliest),
            creation_latest: onlyYear(item?.creation_latest),
            sheet_dimensions: item?.sheet_dimensions?.label,
          };
          filTableData.push(item_obj);
        });
        setFilterNegData(filTableData);
        setLoading(false);
      } catch (error) {
        unexpectedError(error);
      }
    }
    fetchData();
  }, [props.objectData]);

  const complete = async values => {
    Modal.destroyAll();
    values = { ...values, object_status: 1 };
    await onSave(values);
  };
  const incomplete = async values => {
    Modal.destroyAll();
    values = { ...values, object_status: 0 };
    await onSave(values);
  };
  let onFinish = async (values, action = null) => {
    saveAndNext = '';
    if (!!action) {
      saveAndNext = action;
    }
    await confirmationModal(values, 'Status', 'Is this record complete or incomplete?', 'Incomplete', 'Complete', complete, incomplete);
  };

  // Create/update the print information
  let onSave = async values => {
    setLoading(true);
    values.creation_date_start_year = formatDate(values.creation_date_start_year);
    values.creation_date_end_year = formatDate(values.creation_date_end_year);
    const formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (!!value && !!value.fileList) {
        value.fileList.length > 0 ? formData.append(key, value.fileList[0].originFileObj) : '';
      } else {
        key == 'date_confidence' ? formData.append(key, JSON.stringify(value)) : formData.append(key, value);
      }
    });
    formData.append('collection_id', props.objectData.collections);
    dispatch(userActions.collectionObject(formData, 'print/print', !!props.objectData.print && props.objectData.print.id))
      .then(
        response => {
          setLoading(false);
          if (response) {
            setLoading(false);
            if (response.error) {
              notification['error']({
                message: response.error,
                duration: 2,
              });
            } else {
              notification['success']({
                message: 'Print saved successfully!',
                duration: 2,
              });
              localStorage.setItem('thumbnail', newThumbnail);
              formRef.current.resetFields(['technique_doc']);
              formRef.current.setFieldsValue({
                technique_doc: response.data.technique_doc,
              });
              props.objectData['print'] = response.data;
              setPrint(response.data);
              if (saveAndNext == '') {
                setTimeout(() => props.history.push('/print-objects', 1500));
              } else if (saveAndNext == 'next') {
                props.onChange(props.objectData, '3', 'Physical Characteristics');
              }
            }
          }
        },
        errorReponse => {
          setLoading(false);
          if (errorReponse.errors !== undefined) {
            for (var i = 0; i < errorReponse.errors.length; i++) {
              var errorObj = errorReponse.errors[i];
              var errorField = errorObj.extensions.field;
              var errorFieldMessage = errorObj.message;
              notification.error({
                message: errorFieldMessage,
                duration: 2,
              });
              formRef.current.setFields([
                {
                  name: errorField,
                  errors: [errorFieldMessage],
                },
              ]);
            }
          } else {
            setLoading(false);
            unexpectedError();
          }
        }
      )
      .catch(error => {
        setLoading(false);
        notification.error({
          message: 'Not Saved!',
          duration: 2,
        });
      });
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    props.onChange('', '1', 'Edit Object');
  };
  const getNegativeThumbnail = async e => {
    setLoading(true);
    let negData = negativeData.filter(obj => obj.id == e);
    let thumbnail = '';
    if (negData.length > 0) {
      if (negData?.[0]?.thumbnail) {
        thumbnail = await dispatch(userActions.getFile(negData[0].thumbnail));
      }
      formRef.current.setFieldsValue({
        object_name: negData[0].obj_name,
        alt_obj_name: negData[0].alt_obj_name,
        creation_earliest: onlyYear(negData[0]?.creation_earliest),
        creation_latest: onlyYear(negData[0]?.creation_latest),
        sheet_dimensions: negData[0]?.sheet_dimensions?.label,
      });
    }
    setThumbnail(thumbnail);
    setLoading(false);
  };
  const showThumbnail = () => {
    setPreviewVisible(true);
  };
  const onFinishFilter = async values => {
    setLoading(true);
    try {
      const response = await dispatch(userActions.negativeFilter(values));
      setFilterNegData(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      unexpectedError(error);
    }
  };

  const negFilter = (record, data) => {
    selectedNegative == record ? setSelectedNegative(null) : setSelectedNegative(record);
    setNegRecord(data);
  };
  const onFinishFilterFailed = ({ errorFields }) => {
    filterFormRef.current.scrollToField(errorFields[0].name);
  };
  const showModal = () => {
    formRef.current.setFieldsValue({ negative_id: selectedNegative });
    setOpen(true);
  };
  const cancelFilterModal = () => {
    setOpen(false);
    filterFormRef.current.setFieldsValue('');
  };
  const handleModalOk = () => {
    formRef.current.setFieldsValue({
      object_name: !!negRecord ? negRecord.obj_name : print.object_name,
      alt_obj_name: !!negRecord ? negRecord.alt_obj_name : print.alt_obj_name,
      negative_id: selectedNegative,
    });
    cancelFilterModal();
  };
  const showMovablePortfolio = async (conceptID, edition_set = null) => {
    setLoading(true);
    formRef.current.setFieldsValue({ edition_set: '' });
    setMovablePortfolio([]);
    setLoading(false);
    if (!!conceptID) {
      const { data: movableData } = await dispatch(
        userActions.getItems('portfolio', {
          fields: ['id', 'name', 'number', 'type.name', 'edition_number'],
          limit: '-1',
          filters: { conceptual_number: { _eq: conceptID } },
        })
      );
      let editionNumber = print?.edition_set ?? edition_set;
      !!movableData.some(obj => obj['id'] === editionNumber)
        ? formRef.current.setFieldsValue({
            edition_set: editionNumber,
          })
        : formRef.current.setFieldsValue({ edition_set: '' });
      setMovablePortfolio(movableData);
      setLoading(false);
    }
  };
  const handleSaveAndNext = action => {
    formRef.current.validateFields().then(values => {
      onFinish(values, action);
    });
  };

  const columns = [
    {
      title: 'Thumbnail',
      dataIndex: 'thumbnail',
      key: 'thumbnail',
      render: (text, record) =>
        record.thumbnail ? (
          <PictureCell dataIndexValue={record.thumbnail} getFile={() => dispatch(userActions.getFile(record.thumbnail))} width={50} />
        ) : (
          <span>-</span>
        ),
    },
    {
      title: 'Collection Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...filter('name'),
      onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Common Title',
      dataIndex: 'obj_name',
      key: 'obj_name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...filter('obj_name'),
      onFilter: (value, record) => record.obj_name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Acquisition id',
      dataIndex: 'acquisition',
      key: 'acquisition',
      ...filter('acquisition'),
      onFilter: (value, record) => record.acquisition.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Select',
      key: 'select',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            {
              // Hide delete and edit permission for readonly user
              props.roleType !== 'readOnly' ? (
                <Tooltip placement="top" title="Select Negative">
                  <Radio.Group value={selectedNegative} onChange={event => negFilter(event.target.value, record)}>
                    <Radio value={record.id} onClick={event => negFilter(event.target.value, record)} />
                  </Radio.Group>
                </Tooltip>
              ) : (
                ''
              ) // end here
            }
          </div>
        </span>
      ),
    },
  ];
  return (
    <Spin spinning={loading} size="large">
      <div className="artist">
        <Form
          ref={formRef}
          layout="vertical"
          {...formItemLayout}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ layout: tailFormItemLayout }}
        >
          <Form.Item name="object_id" noStyle initialValue={props.objectData.id}>
            <Input type="hidden" />
          </Form.Item>
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item name="title">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item name="acquisition">
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              {!!newThumbnail ? (
                <img onClick={showThumbnail} alt="Not available" style={{ width: 170 }} src={newThumbnail}></img>
              ) : (
                <p>
                  <InfoCircleOutlined style={{ fontSize: 15 }} /> <span style={{ marginLeft: 5 }}>Negative thumbnail not available!</span>
                </p>
              )}
              {/* <Modal visible={previewVisible} title="Preview Thumbnail" footer={null} onCancel={handleCancel}>
                  <div style={{ textAlign: 'center' }}>
                    <img
                      alt="example"
                      style={{
                        width: '100%',
                        height: 'auto',
                        textAlign: 'center',
                      }}
                      src={newThumbnail}
                    />
                  </div>
                </Modal> */}
            </Col>
          </Row>
          <Divider />
          {/* bhawana */}
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="negative_id"
                className="labelLink"
                label={
                  <div
                    style={{
                      justifyContent: 'space-between',
                      width: '100%',
                      textAlign: 'center',
                      display: 'flex',
                    }}
                  >
                    Negative
                    <Tooltip placement="rightTop" title="Advance Negative Search">
                      <a style={{ color: '#a6a300', cusrsor: 'pointer' }} onClick={showModal}>
                        Advance filter
                      </a>
                    </Tooltip>
                  </div>
                }
                rules={[
                  {
                    required: true,
                    message: 'Nagative is required!',
                  },
                ]}
              >
                <Select
                  showSearch
                  allowClear
                  placeholder="Select a negative"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  onChange={getNegativeThumbnail}
                >
                  {negativeData.map(neg => {
                    return <Select.Option key={neg.id} value={neg.id}>{!!neg.dummy ? `${neg.obj_name} - Draft` : neg.obj_name}</Select.Option>;
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="object_name"
                label="Common Title"
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: 'Common title is required!',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="alt_obj_name" label="Alt Object Name / Title">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          {/* <Col xs={24} sm={12} md={12} lg={12}>
                <Form.Item name="artist_print_id" label="Artist Print ID">
                  <Input />
                </Form.Item>
              </Col> */}
          <Divider />
          <Row gutter={24}>
            {/* <Col xs={24} sm={12} md={12} lg={12}>
                <Form.Item name="secondary_print_id" label="Secondary Print ID">
                  <Input />
                </Form.Item>
              </Col> */}
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="portfolio_add_number" label="Portfolio / Additional number">
                <Select
                  showSearch
                  allowClear
                  placeholder="Select a portfolio"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.includes(input)}
                  onChange={showMovablePortfolio}
                >
                  {portfolios.map(
                    port =>
                      port.type.name.toLowerCase().includes('conceptual') && <Select.Option key={port.id} value={port.id}>{port.name}</Select.Option>
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="edition_set" label="Edition / Set #">
                <Select
                  showSearch
                  allowClear
                  placeholder="Select edition / set #"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.includes(input)}
                >
                  {movablePortfolio.map(port => (
                    <Select.Option key={port.id} value={port.id}>{port.edition_number}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="obj_desc" label="Object Description">
                <Input.TextArea placeholder="Object Description" />
              </Form.Item>
            </Col>
          </Row>
          <Divider />
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <label>
                <span style={{ color: '#ff4d4f' }}>* </span>Print Creation Date Earliest
              </label>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="creation_date_start_year"
                    rules={[
                      {
                        validator: async (_, start_year) => {
                          var endDatetime = formRef.current.getFieldValue('creation_date_end_year');
                          if (!!endDatetime && !!start_year && start_year.format('YYYY') > endDatetime.format('YYYY'))
                            return formRef.current.setFieldsValue({
                              creation_date_end_year: '',
                            });
                        },
                      },
                      {
                        required: true,
                        message: 'Please select the start year!',
                      },
                    ]}
                  >
                    <DatePicker picker="year" placeholder="Start Year" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="creation_date_end_year"
                    rules={[
                      {
                        validator: async (_, creation_earliest) => {
                          var startDatetime = formRef.current.getFieldValue('creation_date_start_year');
                          if (!!startDatetime && !!creation_earliest && creation_earliest.format('YYYY') < startDatetime.format('YYYY'))
                            return formRef.current.setFieldsValue({
                              creation_date_start_year: '',
                            });
                        },
                      },
                      {
                        required: true,
                        message: 'Please select the end year!',
                      },
                    ]}
                  >
                    <DatePicker picker="year" placeholder="End Year" />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="date_confidence"
                label="Print Date Confidence"
                rules={[
                  {
                    required: true,
                    message: 'Print date confidence is required!',
                  },
                ]}
              >
                <Select
                  maxTagCount="responsive"
                  mode="multiple"
                  showSearch
                  allowClear
                  placeholder="Select a print date confidence"
                  optionFilterProp="children"
                  showArrow
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                >
                  {dateConfidence.map(el => (
                    <Select.Option key={el.id} value={el.id}>
                      {el.date_confidence}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Divider />
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="work_material"
                label="Work Type, Materials"
                rules={[
                  {
                    required: true,
                    message: 'Work type, materials is required!',
                  },
                ]}
              >
                <Select
                  placeholder="Select a work type, materials"
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                >
                  {supportData.map(
                    el =>
                      el.type === 'work type' &&
                      el.fields === 'material_pos' && (
                        <Select.Option key={el.id} value={el.id}>
                          {el.name}
                        </Select.Option>
                      )
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="materials_detail" label="Material Details">
                <Input placeholder="Enter material details" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="techniques" label="Techniques">
                <Input placeholder="Enter techniques" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="technique_doc"
                label={
                  <div>
                    Technique Documentation
                    <UploadedCheck uploaded={print?.technique_doc} />
                  </div>
                }
              >
                <Upload
                  name="file"
                  fileList={filesState.technique_doc}
                  className="create_object"
                  accept={config.FileType.docType.toString()}
                  beforeUpload={file => {
                    return beforeUpload(file, 'docType');
                  }}
                  onRemove={props.onRemove}
                  maxCount={1}
                  multiple={false}
                  onChange={e => {
                    props.handleFileChange(e, setFilesState, 'technique_doc');
                  }}
                  showUploadList={showFilesList(print?.technique_doc, 'technique_doc')}
                >
                  <UploadTrigger fileType="docType" />
                </Upload>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="work_purpose"
                label="Work Type, Purpose"
                rules={[
                  {
                    required: true,
                    message: 'Work type, purpose is required!',
                  },
                ]}
              >
                <Select
                  showSearch
                  allowClear
                  placeholder="Select a work type, purpose"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                >
                  {supportData.map(
                    el =>
                      el.fields === 'work_purpose' && (
                        <Select.Option key={el.id} value={el.id}>
                          {el.name}
                        </Select.Option>
                      )
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="work_process"
                label="Work Type, Process"
                rules={[
                  {
                    required: true,
                    message: 'Work type, process is required!',
                  },
                ]}
              >
                <Select
                  placeholder="Select a work type, process"
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                >
                  {supportData.map(
                    el =>
                      el.fields === 'work_process_pos' && (
                        <Select.Option key={el.id} value={el.id}>
                          {el.name}
                        </Select.Option>
                      )
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="creation_earliest" label="Negative Start Date">
                <Input disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="creation_latest" label="Negative End Date">
                <Input disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="sheet_dimensions" label="Negative Size">
                <Input disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="work_era" label="Work Type, Era">
                <Select
                  placeholder="Select a work type, Era"
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                >
                  {supportData.map(
                    el =>
                      el.fields === 'work_era' && (
                        <Select.Option key={el.id} value={el.id}>
                          {el.name}
                        </Select.Option>
                      )
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="work_method" label="Work Type, Method">
                <Select
                  placeholder="Select a work type, method"
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                >
                  {supportData.map(
                    el =>
                      el.fields === 'work_method_positive' && (
                        <Select.Option key={el.id} value={el.id}>
                          {el.name}
                        </Select.Option>
                      )
                  )}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item {...tailFormItemLayout}>
            <Button
              style={{
                margin: '0 8px',
                backgroundColor: 'lightgrey',
                color: '#333',
                borderColor: '#333',
              }}
              onClick={backButton}
            >
              Back
            </Button>
            {props.showButton()}
            {props.showButton() != '' ? (
              <Button className="save-btn" type="primary" style={{ margin: '0 8px' }} onClick={() => handleSaveAndNext('next')}>
                Save and Next
              </Button>
            ) : (
              ''
            )}
          </Form.Item>
        </Form>

        {/* modal for advance search */}

        <Modal
          title="Advance Negative Filter"
          open={open}
          footer={[
            <Button
              style={{
                margin: '0 8px',
                backgroundColor: 'lightgrey',
                color: '#333',
                borderColor: '#333',
              }}
              onClick={cancelFilterModal}
            >
              Close
            </Button>,
            <Button key="submit" type="primary" loading={loading} onClick={handleModalOk}>
              Ok
            </Button>,
          ]}
          confirmLoading={loading}
          onCancel={cancelFilterModal}
          width={1200}
        >
          <div>
            <Form
              ref={filterFormRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinishFilter}
              onFinishFailed={onFinishFilterFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              <Row gutter={24}>
                <Col xs={24} sm={6} md={6} lg={6}>
                  <Form.Item name="keyword" label="Keyword">
                    <Input placeholder="Type... " />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6} md={6} lg={6}>
                  <Form.Item name="obj_name" label="Common Title">
                    <Input placeholder="Type..." />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6} md={6} lg={6}>
                  <Form.Item name="creator" label="Artist / Creator">
                    <Select showSearch allowClear placeholder="Select artist" optionFilterProp="children">
                      {artist.map(val => (
                        <Select.Option key={val.id} value={val.id}>
                          {val.First_Name} {val.last_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6} md={6} lg={6}>
                  <Form.Item>
                    <Button className="save-btn" type="primary" style={{ margin: '25px 8px' }} htmlType="submit">
                      Search
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <hr />
                <div className="artist-list" id="negative_filter_table">
                  <Table
                    className="no-fixed-last-col"
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    bordered
                    rowKey={record => record.id}
                    dataSource={filterNegData}
                    loading={loading}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Modal>

        {/* end advance filter modal */}
      </div>
    </Spin>
  );
};
export default CreatePrint;
